import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "relative rounded-md shadow-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "w-4 h-4",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "flex flex-col mt-4" }
const _hoisted_6 = { class: "text-right col-span-full" }
const _hoisted_7 = { class: "flex flex-col mt-4 overflow-hidden" }
const _hoisted_8 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_9 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_10 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_11 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " タイトル "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 表示数 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " クリック数 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 表示期間 "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_13 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_14 = { class: "px-6 py-4 text-gray-500 whitespace-nowrap" }
const _hoisted_15 = { class: "block font-bold" }
const _hoisted_16 = { class: "block text-xs" }
const _hoisted_17 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_19 = {
  key: 0,
  class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap"
}
const _hoisted_20 = {
  key: 1,
  class: "px-6 py-4 text-xs text-gray-500 whitespace-nowrap"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "flex justify-start items-center" }
const _hoisted_23 = ["onClick"]

import moment from "moment";
import Topic from "@/models/Topic";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref, watch } from "vue";

// interface TrendListState {
//   // is_loading: boolean;
//   keyword: string;
//   topics: Topic[];
//   last_evaluated_key: string | null;

//   is_confirming: boolean;
//   deletion_target: Topic | null;
// }


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendList',
  setup(__props) {

// import { defineComponent } from "vue";
const PAGE_SIZE = 20;

const store = useStore();
const route = useRoute();
const router = useRouter();

// export default defineComponent({
//   components: {
//     ConfirmDialog,
//   },

//   data() {
//     return {
//       // is_loading: false,
//       keyword: "",

const keyword = computed(() => {
  if (route.query._k) {
    return route.query._k.toString();
  }
  return null;
});

const topics = ref<Topic[]>([]);
const last_evaluated_key = ref<string | null>();

const is_confirming = ref<boolean>(false);
const deletion_target = ref<Topic | null>(null);

//     } as TrendListState;
//   },

//   computed: {
//     dialog_title(): string {
//       if (!deletion_target) {
//         return "";
//       }
//       return "トレンドの削除";
//     },

//     dialog_message(): string {
//       if (!deletion_target) {
//         return "";
//       }
//       return `${deletion_target.title}を削除しますが、よろしいですか？`;
//     },

const dialog_title = computed<string>(() => {
  if (!deletion_target.value) {
    return "";
  }
  return "トレンドの削除";
});

const dialog_message = computed<string>(() => {
  if (!deletion_target.value) {
    return "";
  }
  return `${deletion_target.value.title}を削除しますが、よろしいですか？`;
});

//   },

//   mounted() {
//     refresh();
//   },

watch(route, () => {
  setTimeout(() => {
    if(store.state.is_loading) {
      return;
    }

    refresh();
  }, 500);
});

onMounted(() => {
  refresh();
});

//   methods: {

const onKeywordChanged = (e: Event) => {
  const input = e.target as HTMLInputElement;
  console.log(input.value);
  router.replace(`/trends?_k=${input.value}`);
};

const formatDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

const refresh = () => {
  console.log(`try to search (keyword=${keyword.value})`);

  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await Topic.searchTrend(
        keyword.value,
        last_evaluated_key.value,
        PAGE_SIZE
      );
      topics.value = result.topics;
      last_evaluated_key.value = result.last_evaluated_key;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onConfirmDelete = (topic: Topic) => {
  deletion_target.value = topic;
  is_confirming.value = true;
};

const onDelete = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    if (!deletion_target.value) {
      return;
    }
    try {
      await Topic.delete(deletion_target.value.id);
    } finally {
      store.dispatch("setLoading", false);
    }

    deletion_target.value = null;
    is_confirming.value = false;
    refresh();
  });
};

const onCancelDeletion = () => {
  deletion_target.value = null;
  is_confirming.value = false;
};
//   },
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("input", {
          type: "text",
          name: "price",
          id: "price",
          class: "block w-full py-2 pl-8 pr-3 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-color-2 focus:border-color-2",
          placeholder: "キーワード",
          value: _unref(keyword),
          onChange: onKeywordChanged
        }, null, 40, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: `/topics/trend/system/register`,
          class: "px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-color-3 hover:bg-color-3 focus:outline-none focus:ring-3 focus:ring-offset-3 focus:ring-color-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 新規登録 ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("tbody", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topics.value, (topic) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: topic.id,
                    class: _normalizeClass({ 'bg-gray-100': topic.deleted_at })
                  }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          to: `/topics/${topic.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(topic.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(formatDate(topic.created_at, "YYYY-MM-DD")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(topic.view_count), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(topic.click_count), 1),
                    (!topic.publish_from && !topic.publish_to)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, " 期限なし "))
                      : _createCommentVNode("", true),
                    (topic.publish_from || topic.publish_to)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                          _createTextVNode(_toDisplayString(topic.publish_from
                      ? formatDate(topic.publish_from, "YYYY-MM-DD")
                      : "-"), 1),
                          _hoisted_21,
                          _createTextVNode(" ~ " + _toDisplayString(topic.publish_to
                      ? formatDate(topic.publish_to, "YYYY-MM-DD")
                      : "-"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          class: "bg-blue-500 hover:bg-blue-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center mr-2",
                          to: `/topics/trend/system/${topic.id}/edit`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_fa, {
                              icon: "pen",
                              class: "text-xs"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (!topic.deleted_at)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "bg-red-500 hover:bg-red-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center",
                              onClick: ($event: any) => (onConfirmDelete(topic))
                            }, [
                              _createVNode(_component_fa, {
                                icon: "trash",
                                class: "text-xs"
                              })
                            ], 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (is_confirming.value)
      ? (_openBlock(), _createBlock(ConfirmDialog, {
          key: 0,
          title: _unref(dialog_title),
          message: _unref(dialog_message),
          onOk: onDelete,
          onCancel: onCancelDeletion
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})